import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/selected-orgId-siteId';
import { IdType } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type SelectedOrgSiteIdsState = { selectedOrganizationId: IdType | null; selectedSiteId: IdType | null };

const initState: SelectedOrgSiteIdsState = {
  selectedOrganizationId: null,
  selectedSiteId: null,
};

export const selectedOrgSiteReducer = (state = initState, action: Action): SelectedOrgSiteIdsState => {
  switch (action.type) {
    // set selected organization Id
    case getType(actions.setSelectedOrganizationId):
      return { ...state, selectedOrganizationId: action.payload, selectedSiteId: null };

      // set selected site Id
    case getType(actions.setSelectedSiteId):
      return { ...state, selectedSiteId: action.payload };

      // default
    default:
      return state;
  }
};

export default selectedOrgSiteReducer;
